// extracted by css-extract-rspack-plugin
export default {"rowDisabled":"olhmg"};